import { useState } from "react";
import { toast } from "sonner";
import { Download, FileSpreadsheet, Wallet, Loader2, Lock } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function ExportHub() {
  const { user } = useAuth();
  const isSuper = user?.role === "super_admin";
  const [busy, setBusy] = useState(null);

  const download = async (path, filename, key) => {
    setBusy(key);
    try {
      const res = await api.get(path, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url; a.download = filename; a.click();
      window.URL.revokeObjectURL(url);
      toast.success("Export downloaded");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Export failed"); }
    finally { setBusy(null); }
  };

  const cards = [
    { key: "members", icon: FileSpreadsheet, title: "Full Member Export", desc: "Name, Phone, LGA, Ward, Polling Unit, PVC Status, Reg Date.", path: "/admin/export/members", file: "lbm_members.csv", show: true },
    { key: "payouts", icon: Wallet, title: "Financial / Payout Export", desc: "Member ID, Name, Bank, Account, Reward Status, Amount, Date Paid.", path: "/admin/export/payouts", file: "lbm_payouts.csv", show: isSuper },
  ];

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-heading font-black text-3xl">Data Export Hub</h1>
        <p className="text-muted-foreground">{isSuper ? "Download filtered CSV reports." : `Member export scoped to ${user?.assigned_lga} LGA.`}</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6 max-w-3xl">
        {cards.map((c) => (
          <div key={c.key} data-testid={`export-card-${c.key}`} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4"><c.icon className="w-6 h-6 text-primary" /></div>
            <h3 className="font-heading font-bold text-lg">{c.title}</h3>
            <p className="text-sm text-muted-foreground mt-1 mb-5">{c.desc}</p>
            {c.show ? (
              <Button data-testid={`export-btn-${c.key}`} onClick={() => download(c.path, c.file, c.key)} disabled={busy === c.key} className="rounded-full bg-primary font-bold gap-2">{busy === c.key ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} Download CSV</Button>
            ) : (
              <div className="flex items-center gap-2 text-sm text-muted-foreground"><Lock className="w-4 h-4" /> Super Admin only</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
